import { createFileRoute } from "@tanstack/react-router";
import YoungAdultDiagnosedDepression from "@/pages/articles/YoungAdultDiagnosedDepression";
export const Route = createFileRoute(
  "/diagnosed-with-depression-as-a-young-adult",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Diagnosed With Depression As A Young Adult | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Young adults face unique depression triggers. Learn about TMS, SAINT TMS, and treatment options for depression in your 20s in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Diagnosed With Depression As A Young Adult | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Young adults face unique depression triggers. Learn about TMS, SAINT TMS, and treatment options for depression in your 20s in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/diagnosed-with-depression-as-a-young-adult",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/diagnosed-with-depression-as-a-young-adult",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <YoungAdultDiagnosedDepression />;
}
